import React, { lazy, useEffect, useLayoutEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ProjeLayout from '../../container/proje/Index';
import { setNavigate } from '../../utility/navigateHandler';
import AfetVeriAnalizi from '../../container/afetVeriAnalizi/AfetVeriAnalizi';

// const NotFound = lazy(() => import('../container/pages/404'));
const ProjeDetay = lazy(() => import('../../container/proje/ProjeDetay'));

const ProjeRoot = () => {
  const navigate = useNavigate();

  <div> </div>;

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  const navigate = useNavigate();
  useLayoutEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <Routes>
      <Route path="*" element={<AfetVeriAnalizi />} />
      {/* <Route path="*" element={<ProjeRoot />} /> */}
    </Routes>
  );
});

export default ProjeLayout(FrontendRoutes);
